export default __webpack_public_path__ + "static/media/defaultSilk.778e6f55.svg";